import { useLocation } from "react-router-dom";

export const TableData = () => {
  const location = useLocation();
  // console.log(typeof(location?.state),"++++++++++")

  return {
    tableTitle: "Product",
    onDeleteText: "Are you Sure?",
    onUpdateText: "Are you Sure?",
    tableHead: [
      {
        id: "product_name",
        label: "Product Name",
        // link: "/Movie/MovieDetails",
        color: "var(--gradientColor2)",
        // subText: "HSN",
      },
      // {
      //   id: "product_category",
      //   label: "Category",
      // },
      {
        id: "unit_of_measure",
        label: "Units",
        // isImage: true,
      },

      ,
      // {
      //   id: 'movie_access',
      //   label: 'Access',
      // },
      {
        id: "selling_price",
        label: "Selling Price",
      },
      // {
      //   id: "price",
      //   label: "Price",
      // },
      // {
      //   id: "cost",
      //   label: "Cost",
      // },
      // {
      //   id: "total_downloads",
      //   label: "Downloads",
      //   align: "center",
      // },

      // {
      //   id: "movieViews",
      //   label: "Views",
      //   align: "center",
      // },
      // {
      //   id: 'release_date',
      //   label: 'Release Date',
      //   // subText:"publish_time1"
      // },

      {
        id: "status",
        label: "Status",
      },

      {
        id: "edit",
        label: "Update",
      },
    ].filter((e) => e),
    tableBody: [],
    filterColumn: [
      // {
      //   id: "1",
      // title: "Access Type",
      // name: "movie_access",
      // options:["FREE","TVOD","SVOD"],
      // },
      // // {
      // //   title: undefined
      // // },
      // {
      //   id: "2",
      //   title: "Language",
      //   name: "movie_language",
      //   options: ["English", "Hindi", "Gujarati"],
      // },
      // {
      //   id: "3",
      //   title: "Category",
      //   name: "movie_category",
      //   default:
      //     typeof location?.state != "object" && location.state == null
      //       ? location?.state
      //       : null,
      //   options: ["Action", "Comedy", "Drama", "Horror"],
      // },
      // {
      //   id: "3",
      //   title: "Sub Category",
      //   name: "movie_subcategory",
      //   options: ["Action", "Comedy", "Drama", "Horror"],
      //   displayOn: "movie_category",
      // },
    ],
  };
};
